import { PageRouteBuilder } from "@common/route/page-route-builder";
import { SeedDatabasePageComponent } from "./seed-database-page.component";

export const seedDatabasePageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-seed-database-page", SeedDatabasePageComponent)
    .requiresLogin()
    .atUrl("/tools/seed-database")
    .withTitle("Seed Test Organisations")
    .build();
